module.exports = __webpack_public_path__ + "img/TradingView-icon15.0799b717.svg";